/**
 * Rewardful - client-only plugin
 *
 * Injects the Rewardful scripts directly into the document to avoid Nuxt 4 / Unhead v2
 * mishandling of inline script `children` (rendered as attribute instead of script body).
 */
import {defineNuxtPlugin} from '#app';

export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return;

  // Stub: sets up queue before main script loads
  const stub = document.createElement('script');
  stub.textContent = `(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');`;
  document.head.appendChild(stub);

  // Main Rewardful script
  const main = document.createElement('script');
  main.src = 'https://r.wdfl.co/rw.js';
  main.async = true;
  main.setAttribute('data-rewardful', '294b23');
  document.head.appendChild(main);
});
